import React from 'react';
import styles from './index.module.scss';
import Layout from '../layout';
import BrandButton from '../brand-button';

// Посилання на телеграм-бот задане у вимогах до SMS-форми.
const TELEGRAM_LINK = 'https://t.me/pmu_support_bot?start=db_validation';

// Фінальний екран після збереження відгуку.
const SuccessScreen = () => (
  <Layout contentClassName={styles.content}>
    <p className={styles.title}>
      Чудово!
      <br />
      Дякуємо тобі за приділений час 💜
    </p>
    <p className={styles.subtitle}>
      Переглянути більше інформації про продукти та компанію можна у офіційному
      Телеграм-боті <b>Mr.Philip</b>😎⬇️
    </p>
    <BrandButton
      className={styles.button}
      onClick={() => window.open(TELEGRAM_LINK, '_blank')}
    >
      Перейти у Mr. Philip
    </BrandButton>
  </Layout>
);

export default SuccessScreen;
